module.exports = __webpack_public_path__ + "static/TT-Plans-BART-d8cdc2a3d907101c35a6fa9957eca508.pdf";